// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ORG0c","title":"Info_title__2z2xh","selects":"Info_selects__2k9ih","requiredAsterisk":"Info_requiredAsterisk__qyLR4"};